import React, { useState, useEffect } from "react";
import { useSubheader } from "@metronic/layout";
import { Alert } from "react-bootstrap";
import Pagination from "react-js-pagination";
import GeneralFilter from "@components/shared/general-filter";
import GeneralTable from "@components/shared/general-table";
import { getAllToday } from "@services/cases";
import CaseContext from "@contexts/case-context";
import { IfHasRoleByLocalStorage } from "@metronic/_helpers";

const GeneralConsult = (props) => {
  const params = new URLSearchParams(props.location.search);
  const isInsuranceMode = params.get("modo") === "aseguradora";

  const subheader = useSubheader();

  const [casesRecord, setCasesRecord] = useState([]);
  const [paramsPagination, setParamsPagination] = useState({
    activePage: 1,
    totalPages: null,
    itemsCountPerPage: null,
    totalItemsCount: 0,
  });
  
  // Define insurance mode module options
  const insuranceModuleOptions = [
    { value: '3', label: 'Seguimiento' },
    { value: '4', label: 'Informacion Medica' },
    { value: '7', label: 'Alta Paciente' },
    { value: '13', label: 'Seguimiento Extrahospitalario' },
    { value: '2', label: 'Mesa de Control' },
    { value: '5', label: 'Dictamen Medico' },
    { value: '6', label: 'Control de Costos' },
    { value: '12', label: 'Dictamen Extemporáneo' }
  ];

  const getAllCasesByStatus = (pageNumber) => {
    var queryParams = [];

    if (IfHasRoleByLocalStorage("ADMIN_REGION_CELULA")) {
      queryParams = ['&byRegion=true', '&byCell=true'];
    }

    getAllToday(pageNumber, queryParams).then((response) => {
      setCasesRecord(response.data);
      setParamsPagination({
        activePage: pageNumber,
        totalPages: response.totalPages,
        itemsCountPerPage: response.size,
        totalItemsCount: response.totalElements,
      });
    });
  }

  const handlePageChange = async (pageNumber) => {
    setParamsPagination({ ...paramsPagination, activePage: pageNumber, updatePage: true });

    if (!paramsPagination.hasOwnProperty("fromFilter")) {
      getAllCasesByStatus(pageNumber);
    }
  }

  useEffect(() => {
    subheader.setTitle(`Consulta General ${params.get("modo")}`);
  }, [params, subheader]);

  useEffect(() => {
    getAllCasesByStatus(paramsPagination.activePage);
  }, []);

  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        Consulta General {params.get("modo")}
      </Alert>

      <CaseContext.Provider value={[
        casesRecord, setCasesRecord,
        paramsPagination, setParamsPagination
      ]}>
        <GeneralFilter
          statuses={[]}
          hideStatusPatient={false}
          hideModule={!isInsuranceMode}
          hideInsurance={isInsuranceMode}
          hideHospital={params.get("modo") === "hospital"}
          hideHospitalInvoice={true}
          hidePresumptiveDiagnosis={true}
          hideCategoryVip={true}
          hideDiffDays={params.get("modo") === "hospital"}
          hideAmount={params.get("modo") === "hospital"}
          hideAxaCategoryId={params.get("modo") === "hospital"}
          moduleOptions={isInsuranceMode ? insuranceModuleOptions : []}
          extraOptions={<option value="Cancelado">Cancelado</option>}
        />
      </CaseContext.Provider>

      <GeneralTable
        urlToGo="/consulta_general_detalles/"
        activePage={paramsPagination.activePage}
        totalItemsCount={paramsPagination.totalItemsCount}
        data={casesRecord}
        hideFlagsColumn={true}
        hideReasonColumn={true}
        hideAxaCategoryColumn={params.get("modo") === "hospital"}
        hidePatientStatusColumn={true}
        hideTabulationColumn={true}
        hideCelulaColumn ={params.get("modo") === "hospital"}
      />

      <div className="d-flex justify-content-center">
        <Pagination
          activePage={paramsPagination.activePage}
          itemsCountPerPage={paramsPagination.itemsCountPerPage}
          totalItemsCount={paramsPagination.totalItemsCount}
          pageRangeDisplayed={10}
          itemClass="page-item"
          linkClass="btn btn-light"
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default GeneralConsult;

